import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex mt-4 px-3 mb-2" }

import SingleOperationOfficeAutoComplete from "@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue"
import ParentDepartmentAutoComplete from "@/components/Department/ParentDepartmentAutoComplete.vue"
import getDepartmentAllParams from "@/types/responses/getDepartmentAllParams"
import getOperationOffice from "@/types/responses/getOperationOffice"
import getDepartmentResponse from "@/types/responses/getDepartment"
import SelectLevel from "@/components/Department/SelectLevel.vue"
import { DEPARTMENT_SELECTABLE_LEVEL } from "@/services/consts"
import { isSecondLevelDepartment } from "@/services/functions"
import FormRow from "@/components/Common/FormRow.vue"
import { computed } from "vue"
import i18n from "@/lang/i18n"

type formType = {
  operation_office: getOperationOffice | null
  level: { key: number, label: string }
  parent: getDepartmentResponse | null
  id_for_customer: string
  name: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOrUpdateModalContent',
  props: {
    modelValue: {},
    department: {},
    parentIdExistsDepartments: {},
    initialOperationId: {},
    isDepartment: { type: Boolean },
    isChildDepartment: { type: Boolean },
    isRequired: { type: Boolean },
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const isDisabledDepartment = computed(() => {
  if (!props.department) return false
  return !!props.parentIdExistsDepartments.filter((department) => {
    return department.parent_id == props.department?.id
  }).length
})

const selectableLevel = computed(() => {
  if (isDisabledDepartment.value) return [DEPARTMENT_SELECTABLE_LEVEL[0]]
  if (props.isRequired) return [DEPARTMENT_SELECTABLE_LEVEL[1]]
  return DEPARTMENT_SELECTABLE_LEVEL
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FormRow, {
      title: _unref(i18n).global.t('pages.departments.createOrUpdateModal.operationOffice'),
      required: true,
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(SingleOperationOfficeAutoComplete, {
          modelValue: modelValue.value.operation_office,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.operation_office) = $event)),
          initialOperationId: props.department?.operation_office_id,
          required: false,
          errorMessages: props.errors.operation_office_id,
          clearable: false,
          readonly: props.isChildDepartment
        }, null, 8, ["modelValue", "initialOperationId", "errorMessages", "readonly"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(FormRow, {
      title: _unref(i18n).global.t('pages.departments.createOrUpdateModal.selectLevel'),
      required: true
    }, {
      default: _withCtx(() => [
        _createVNode(SelectLevel, {
          modelValue: modelValue.value.level,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.level) = $event)),
          items: selectableLevel.value,
          errorMessages: props.errors.level
        }, null, 8, ["modelValue", "items", "errorMessages"])
      ]),
      _: 1
    }, 8, ["title"]),
    (_unref(isSecondLevelDepartment)(modelValue.value.level.key))
      ? (_openBlock(), _createBlock(FormRow, {
          key: 0,
          title: _unref(i18n).global.t('pages.departments.createOrUpdateModal.department'),
          required: true
        }, {
          default: _withCtx(() => [
            _createVNode(ParentDepartmentAutoComplete, {
              modelValue: modelValue.value.parent,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.parent) = $event)),
              operationOffice: modelValue.value.operation_office,
              departmentId: props.department?.parent_id,
              exceptionId: props.department?.id,
              disabled: isDisabledDepartment.value,
              isDepartment: props.isDepartment,
              isChildDepartment: props.isChildDepartment,
              errorMessages: props.errors.parent_id
            }, null, 8, ["modelValue", "operationOffice", "departmentId", "exceptionId", "disabled", "isDepartment", "isChildDepartment", "errorMessages"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_text_field, {
        modelValue: modelValue.value.id_for_customer,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.id_for_customer) = $event)),
        label: _unref(i18n).global.t('pages.departments.createOrUpdateModal.idForCustomer'),
        outlined: "",
        dense: "",
        class: "mr-4",
        "error-messages": props.errors.id_for_customer,
        maxlength: "255"
      }, null, 8, ["modelValue", "label", "error-messages"]),
      _createVNode(_component_v_text_field, {
        modelValue: modelValue.value.name,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue.value.name) = $event)),
        label: _unref(i18n).global.t('pages.departments.createOrUpdateModal.name'),
        outlined: "",
        dense: "",
        "error-messages": props.errors.name,
        maxlength: "255"
      }, null, 8, ["modelValue", "label", "error-messages"])
    ])
  ], 64))
}
}

})